// extracted by mini-css-extract-plugin
module.exports = {"packageDetailsContainer":"ViewPackageDetails_packageDetailsContainer__3cF7w","title":"ViewPackageDetails_title__2R8Ii","detailItem":"ViewPackageDetails_detailItem__1Ru5W"};